import { render, staticRenderFns } from "./CallpopHistoryView.vue?vue&type=template&id=b1c00990&scoped=true"
import script from "./CallpopHistoryView.vue?vue&type=script&lang=js"
export * from "./CallpopHistoryView.vue?vue&type=script&lang=js"
import style0 from "./CallpopHistoryView.vue?vue&type=style&index=0&id=b1c00990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c00990",
  null
  
)

export default component.exports